import {NewSideMenu} from './new-side-menu';

export default NewSideMenu; // eslint-disable-line
